
import * as React from 'react';
import {
  IDetailsListProps
} from 'office-ui-fabric-react/lib/DetailsList';
import { withCurrentItemSet, IDecorateWithCurrentItemSetProps } from '../decorators/selectors';
import { withCurrentGroups, IDecorateWithCurrentGroupsProps } from '../decorators/withCollapsibleGroups';
import {
  withItemSetSelection, IDecorateConnectToSelectionProps
} from '../decorators/connectToSelection';
import { withPageLoadTracker, IDecorateWithPageLoadTrackerProps } from '../decorators/withPageLoadTracker';
import { asLayout, IDecorateAsLayoutProps } from '../layoutManager/LayoutManager';
import { detailsLayoutType, compactDetailsLayoutType } from './DetailsLayoutTypeFacet';
import { IItemSetDetailsListProps, ItemSetDetailsList } from '../itemSetDetailsList/ItemSetDetailsList';
import { injectProps } from '../../utilities/components/Props';
import { withSelectedItemsContextMenu, IDecorateWithSelectedItemsContextMenuProps } from '../decorators/withSelectedItemsContextMenu';

const CurrentItemSetDetailsList = withCurrentGroups()(ItemSetDetailsList);
const InvokableDetailsList = withSelectedItemsContextMenu()(CurrentItemSetDetailsList);
const SelectionDetailsList = withItemSetSelection()(InvokableDetailsList);
const PageLoadDetailsList = withCurrentItemSet()(withPageLoadTracker([])(SelectionDetailsList));

export type IDetailsLayoutProps =
  IDecorateAsLayoutProps<IDecorateWithPageLoadTrackerProps<
  IDecorateConnectToSelectionProps<
  IDecorateWithSelectedItemsContextMenuProps<
  IDecorateWithCurrentGroupsProps<
  IDecorateWithCurrentItemSetProps<
  IItemSetDetailsListProps
  >
  >
  >,
  Pick<IDetailsListProps, 'selection'>,
  {}
  >
  >>;

export const DetailsLayout: React.ComponentType<IDetailsLayoutProps> = asLayout(detailsLayoutType)(PageLoadDetailsList);

export const CompactDetailsLayout: React.ComponentType<IDetailsLayoutProps> = asLayout(compactDetailsLayoutType)(
  injectProps((): Pick<IDetailsLayoutProps, 'compact'> => {
    return {
      compact: true
    };
  })(PageLoadDetailsList)
);
